import VariationData from './variation_data'
import TrackingService from './tracking_service'
import {wishlist} from "@otto-ec/nexus-registry/wishlist";

export default class PromoArticlelist {
    constructor() {
        this.trackingService = new TrackingService()
    }

    enrichMoreArticlesLink(container) {
        const moreArticlesLink = container.querySelector('.promo_articlelist--more-articles-link > oc-button-v1');
        if (moreArticlesLink) {
            const pageCluster = window.o_util.misc.getPagecluster();
            let currentTracking = moreArticlesLink.dataset.trV1Click;
            currentTracking = currentTracking.replace('{{PAGECLUSTER}}', pageCluster);
            moreArticlesLink.dataset.trV1Click = currentTracking;
        }
    }

    initVisualState(container) {
        container
            .querySelectorAll('.promo_articlelist--article-wishlistheart')
            .forEach((heartBtn) => this.updateVisualHeartState(heartBtn, false))
    }

    addClickHandlers(container) {
        container
            .querySelectorAll('.promo_articlelist--article-link')
            .forEach((link) => {
                link.addEventListener('click', function () {
                    window.o_promo_articlelist.trackClick(link)
                })
            })
        container
            .querySelectorAll('.promo_articlelist--article-wishlistheart')
            .forEach((heartBtn) => {
                heartBtn.addEventListener('click', function () {
                    window.o_promo_articlelist.toggleWishlistHeart(heartBtn)
                })
            })
    }

    trackView(container) {
        const items = container.querySelectorAll('.promo_articlelist--article')
        const variations = [].map.call(items, (item) => this._createVariationData(item, undefined))
        const featureOrder = this._getFeatureOrder(container)
        const featureIndex = this._getFeatureIndex(container)
        const hasMoreArticlesButton = this._hasMoreArticlesButton(container)
        this.trackingService.sendViewTrackingEvent(
            featureOrder,
            featureIndex,
            variations,
            hasMoreArticlesButton,
        )
    }

    registerScrollTrackObserver(container) {
        const featureIndex = this._getFeatureIndex(container)
        const items = container.querySelectorAll('.promo_articlelist--article')
        /*                                     */
        const observer = new IntersectionObserver((entries) => {
            const intersectingEntries = entries.filter(
                (entry) => entry.isIntersecting,
            )
            if (intersectingEntries.length > 0) {
                const positionsToTrack = intersectingEntries.map((entry) =>
                    this._getArticlePosition(entry.target),
                )
                this.trackingService.sendScrollTrackingEvent(
                    featureIndex,
                    positionsToTrack,
                )
            }
            intersectingEntries.forEach((entry) =>
                observer.unobserve(entry.target),
            )
        })
        items.forEach((item) => observer.observe(item))
    }

    async toggleWishlistHeart(heartBtn) {
        const articleTile = this._findParentArticle(heartBtn)
        const wishlistedAttribute = 'data-is-wishlisted'
        const wasWishlisted = heartBtn.getAttribute(wishlistedAttribute) === 'true';
        const isWishlisted = !wasWishlisted;
        heartBtn.setAttribute(wishlistedAttribute, isWishlisted);
        this.updateVisualHeartState(heartBtn, isWishlisted);
        const variationId = articleTile.getAttribute('data-variation-id')
        if (isWishlisted) {
            await wishlist.addItem(variationId, false, "PromoArticleList")
        } else {
            await wishlist.deleteItem(variationId, "PromoArticleList");
        }
    }


    updateVisualHeartState(heartBtn, isWishlisted) {
        heartBtn.icon = isWishlisted ? 'wishlist-active' : 'wishlist'
        heartBtn.setAttribute('oc-aria-label', isWishlisted ? 'Artikel vom Merkzettel entfernen' : 'Artikel merken')
        heartBtn.setAttribute('icon-color', isWishlisted ? 'var(--oc-semantic-color-brand)' : '')
    }

    trackClick(item) {
        const container = this._findParentContainer(item)
        const articleContainer = this._findParentArticle(item)
        const featureOrder = this._getFeatureOrder(container)
        const featureIndex = this._getFeatureIndex(container)
        const items = container.querySelectorAll('.promo_articlelist--article')
        const filledSlots = items.length
        const hasMoreArticlesButton = this._hasMoreArticlesButton(container)
        const isOnWishlist = this._isOnWishlist(container, articleContainer)
        const position = this._getArticlePosition(articleContainer)
        const variation = this._createVariationData(
            articleContainer,
            isOnWishlist,
        )

        this.trackingService.sendClickTrackingEvent(
            featureOrder,
            featureIndex,
            filledSlots,
            position,
            variation,
            hasMoreArticlesButton,
        )
    }

    _hasMoreArticlesButton(container) {
        if (!container) {
            return false
        }

        const moreArticlesButton = container.querySelector('.promo_articlelist--more-articles-link')
        return moreArticlesButton ? true : false
    }

    _isOnWishlist(container, articleContainer) {
        if (container.getAttribute('data-wishlist-heart-enabled') === 'true') {
            const heartBtn = articleContainer.querySelector('.promo_articlelist--article-wishlistheart');
            if (!heartBtn) {
                return false;
            }
            return articleContainer.querySelectorAll('[data-is-wishlisted="true"]').length > 0
        }


        return undefined
    }

    _createVariationData(article, isOnWishlist) {
        return new VariationData(
            article.getAttribute('data-variation-id'),
            isOnWishlist,
            article.querySelector(
                '.promo_articlelist--description-name',
            ).innerHTML,
        )
    }

    _findParentContainer(elem) {
        while (
            !elem.classList.contains('promo_articlelist--container') &&
            (elem = elem.parentElement)
            ) ;
        return elem
    }

    _findParentArticle(elem) {
        while (
            !elem.classList.contains('promo_articlelist--article') &&
            (elem = elem.parentElement)
            ) ;
        return elem
    }

    _getFeatureOrder(container) {
        return parseInt(
            container.parentElement.getAttribute('data-feature-order'),
            0,
        )
    }

    _getFeatureIndex(container) {
        return parseInt(container.getAttribute('data-feature-index'), 0)
    }

    _getArticlePosition(articleContainer) {
        return parseInt(articleContainer.getAttribute('data-article-position'))
    }
}
